/** Eventi di riproduzione (per i test e2e) e registro degli ultimi errori (per l'heartbeat). */

export type PlayerEventType = 'show' | 'hide' | 'ended' | 'playing';

export interface PlayerEvent {
  t: number; // performance.now()
  type: PlayerEventType;
  slot: string | null;
  scheduleId: string | null;
  assetId?: string | null;
}

export interface EventSink {
  push(type: PlayerEventType, slot: string | null, scheduleId: string | null, assetId?: string | null, durationMs?: number | null): void;
}

export class EventLog implements EventSink {
  readonly events: PlayerEvent[] = [];
  constructor(private readonly max = 5000, private readonly now: () => number = () => performance.now()) {}

  push(type: PlayerEventType, slot: string | null, scheduleId: string | null, assetId?: string | null): void {
    this.events.push({ t: this.now(), type, slot, scheduleId, assetId: assetId ?? null });
    if (this.events.length > this.max) this.events.splice(0, this.events.length - this.max);
  }
}

export const NULL_SINK: EventSink = { push() { /* niente */ } };

export class ErrorLog {
  private readonly items: string[] = [];
  constructor(private readonly max = 10) {}

  add(msg: string): void {
    this.items.push(`${new Date().toISOString()} ${msg}`);
    if (this.items.length > this.max) this.items.shift();
  }

  list(): string[] {
    return [...this.items];
  }
}
